<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="12" :sm="12">
            <label class="title">中心概览</label>
            <a-date-picker @change="searchQuery" style="margin-left: 10px;margin-right: 10px" value-format='YYYY-MM-DD' v-model="queryParam.currentDate" />
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <a-row style="margin-top: 5px;margin-bottom: 5px">
      <a-col :span="24" style="text-align: right">
        <standard-filter @loadData="loadData"></standard-filter>
      </a-col>

    </a-row>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"

        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :scroll="{x:'1000'}"
        :pagination="false"
        :loading="loading"
        @change="handleTableChange">
      </a-table>
    </div>

  </a-card>
</template>

<script>
  import moment from 'moment';
  import {putAction,getFileAccessHttpUrl} from '@/api/manage';
  import {frozenBatch} from '@/api/api'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import {CACHE_PROJECT_ID} from '@/constants/project'
  import { getAction,postAction } from '@/api/manage'

  import Vue from 'vue'
  import StandardFilter from './StandardFilter'
  export default {
    name: "Center",
    mixins: [JeecgListMixin],
    components: {
      StandardFilter

    },
    data() {
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        queryParam: {},
        columns:[],
        url: {
          list: "/project/statistic/visitRate/center",
        },
        disableMixinCreated:true,
      }
    },
    computed: {

    },
    mounted(){
      this.queryParam.projectId = this.projectId
      this.$set(this.queryParam,'currentDate',moment().format('YYYY-MM-DD'))
      this.loadData()
      this.loadTitle()
    },
    watch:{
    },
    methods: {
      moment,
      viewItem(row){
        // 查看基线的表单
        this.$emit('change',row.id)
      },
      loadTitle(){
        getAction('/project/projectPeriodItem/list',{projectId:this.projectId,base:'0',halfway:'0'}).then(res=>{
          if(res.success){
            const columns = [
              {
                title: '研究中心',
                align: "center",
                dataIndex: 'name',
                fixed:'left',
                width: 200,
              },
            ]
            res.result.forEach(item=>{
              columns.push({
                title: item.name,
                align: "center",
                children:[{
                  title: '应随访人数',
                  align: "center",
                  dataIndex: 'total'+item.id,
                  width: 120,
                  customRender:(value,row,index)=>{
                    return value!='' && value!= null && value != undefined? value:'0'
                  }
                },
                  {
                    title: '完成随访人数/占比',
                    align: "center",
                    dataIndex: 'submitCount'+item.id,
                    width: 200,
                    customRender:(value,row,index)=>{
                      return value!='' && value!= null && value != undefined? `${value}(${row['submitCountRate'+item.id]}%)`:'0(0%)'
                    }
                  }
                  ,{
                    title: '达标随访人数',
                    align: "center",
                    dataIndex: 'endIsStandard'+item.id,
                    width: 120,
                    customRender:(value,row,index)=>{
                      return value!=''&& value!= null && value != undefined? value:'0'
                    }
                  }]
              },)
            })

            columns.push({
              title: '操作',
              align: "center",
              fixed:'right',
              dataIndex: 'action',
              width: 120,
              customRender: (value, row, index) => {
                const child = this.$createElement('a', {
                  domProps: {
                    innerHTML: '详情'
                  },
                  on: {
                    click: ()=> {
                      this.viewItem(row)
                    }
                  }
                })
                return {
                  children: child,
                  attrs: {},
                };
              },
            })
            this.columns = columns
          }
        })
      },
    }
  }
</script>
<style scoped lang="less">
  .title{
    font-size: 20px;
    font-weight: bold;
    color: @primary-color;
    margin-right: 30px;
  }
</style>
